import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'mixedNotice'];

  connect() {
    this.changeHandler();
  }

  changeHandler() {
    if (this.selectTarget.value === '混載便') {
      this.mixedNoticeTarget.classList.remove('hidden');
    } else {
      this.mixedNoticeTarget.classList.add('hidden');
    }
  }
}
